module.exports = __webpack_public_path__ + "img/pureelegumes.d8e2cdbd.png";